import { writable } from "svelte/store";
import persisted from "./common/persisted.js";

function createStore() {
    const { subscribe, set, update } = writable({
        isPaused: false
    });

    return {
        subscribe,
        set,

        pause(note) {
            update((state) => ({ isPaused: true, note }));
        },

        resume() {
            update((state) => ({ isPaused: false, note: null }));
        }
    };
}

const store = persisted("semaphore:v2", true, createStore());

export default store;
